// ContactInfoSection.js
import React, { useEffect, useRef, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import { FaEdit } from "react-icons/fa";
import InputComponent from "../InputComponent";
import { getValueFromPatToken } from "../../../patient/utils/commonUtils";
import { getValueFromToken } from "../../utils/tokenUtils";
import { showToast } from "../../../patient/utils/toastUtils";
import { serviceUpdatePrimaryEmailRequest, serviceUpdatePrimaryPhoneNumberRequest, serviceVerifyOtpAndUpdate } from "../../services/profileApi";
import { serviceGetUserContactInfo, serviceUpdatePrimaryPhoneNumberAndVerifyOtp, serviceUpdateUserContact } from "../../../patient/services/patientRegistrationRequesApi";

const ContactInfoSection = ({
  collapsed,
  toggleSection,
  callType
}) => {

  const [emails, setEmails] = useState([""]);
  const [contacts, setContacts] = useState([""]);
  const [primaryEmail, setPrimaryEmail] = useState("");
  const [secondaryEmail, setSecondaryEmail] = useState("");
  const [primaryContact, setPrimaryContact] = useState("");
  const [secondaryContact, setSecondaryContact] = useState("");
  const [updatedEmail, setupdatedEmail] = useState(false);
  const [updatedPhone, setupdatedPhone] = useState(false);
  
  const [showSecondaryEmail, setShowSecondaryEmail] = useState(false);
  const [showsecondaryContact, setShowSecondaryContact] = useState(false);
  const [tertiaryPhoneNumber, setTertiaryPhoneNumber] = useState("");

  const [otp, setOtp] = useState("");
  const [editButtonsContactInfo, setEditButtonsContactInfo] = useState(-1);
  const [loginUserId, setLoginUserId] = useState(null);
  const emailInputRef = useRef(null);
  const phoneInputRef = useRef(null);

  useEffect(() => {
    if (editButtonsContactInfo === 1) {
      emailInputRef.current && emailInputRef.current.focus();
    } else if (editButtonsContactInfo === 2) {
      phoneInputRef.current && phoneInputRef.current.focus();
    }
  }, [editButtonsContactInfo]);

  useEffect(() => {
    let temp;
    if(callType === 'patient'){
      temp = getValueFromPatToken("user_id");
    }else{        
      temp = getValueFromToken("user_id");
    }
    setLoginUserId(temp)
  }, []);

  const handleEmailChange = (index, newValue) => {
    if (index === 0) {
      setPrimaryEmail(newValue);
    } else {
      setSecondaryEmail(newValue);
    }
  };

  const handlePhoneChange = (index, newValue) => {
    if (index === 0) {
      setPrimaryContact(newValue);
    } else {
      setSecondaryContact(newValue);
    }
  };

    // update primary email
    const updateEmail = async () => {
      const response = await serviceUpdatePrimaryEmailRequest({
        userId: loginUserId,
        primaryEmailId: primaryEmail,
        callType:callType
      })
  
      if(response?.status){
          setupdatedEmail(true);
          setupdatedPhone(false);
          showToast('OTP sent to your Primary Contact Number.Please verify it to update Email.', "success");
      }else{
        showToast(response?.message, "error");
      }
    };

    const handleAddloginPhone = () => {
      if (contacts.length === 1) {
        setContacts([...contacts, ""]);
        setShowSecondaryContact(true);
      }
    };

    const handleAddLogin = () => {
      if (emails.length === 1) {
        setEmails([...emails, ""]);
        setShowSecondaryEmail(true);
      }
    };

    const handleRemoveLogin = (index) => {
      const newEmails = [...emails];
      newEmails.splice(index, 1);
      setEmails(newEmails);
      setShowSecondaryEmail(false);
      setSecondaryEmail("");
    };
   
  
    const handleRemoveLoginPhone = (index) => {
      const newPhones = [...contacts];
      newPhones.splice(index, 1);
      setContacts(newPhones);
      setShowSecondaryContact(false);
      setSecondaryContact("");
    };

    // verify otp for primary email change
  const verifyOtpEmailUpdate = async () => {
    const response = await serviceVerifyOtpAndUpdate({
      UserId: loginUserId,
      primaryEmailId: primaryEmail,
      enteredOTP: otp,
    });

    if(response?.status){
      setupdatedEmail(false);
      showToast(response?.message,"success")
    }else{
      console.log(response?.message,"error")
      showToast(response?.message,"error")
    }
  };

   // verify and update primary phone number clien
   const verifyOtpPhoneUpdate = async () => {
    const response = await serviceUpdatePrimaryPhoneNumberAndVerifyOtp( {
      UserId: loginUserId,
      primaryNumber: primaryContact,
      enteredOTP: otp,
    })

    if(response?.status){
      setupdatedPhone(false);
      showToast(response?.message,"success")
    }else{
      console.log(response?.message,"error")
      showToast(response?.message,"error")

    }
  };


  // update primary phone number
  const updatePhone = async () => {
    const response = await serviceUpdatePrimaryPhoneNumberRequest({
      userId: loginUserId,
      primaryNumber: primaryContact,
      callType:callType
    })

    if(response?.status){
      setupdatedPhone(true);
      setupdatedEmail(false);
      showToast(response?.message,"success")
    }else{
      console.log(response?.message,"error")
      showToast(response?.message,"error")

    }
  };

    // contactInfo - primary number/email clinc
    const updateContactInfo = async () => {
      const contactInfo = {
        userId: loginUserId,
        secondaryPhoneNumber: secondaryContact === "" ? null : secondaryContact,
        secondaryEmailId: secondaryEmail === "" ? null : secondaryEmail,
        callType:callType
      };
  
    const response = await serviceUpdateUserContact(contactInfo);
    console.log('response',response)
    if(response?.status){ 
      showToast(response?.message,"success")
    }else{
      showToast(response?.message,"error")
    }
    };



  // fetch contact details of user
  const fetchContactInfo = async (id) => {
    const response = await serviceGetUserContactInfo(id);
    if (response?.status && Object.keys(response?.data)?.length) {
      const { contactInfo } = response?.data;

      const {
        primary_phone_number,
        secondary_phone_number,
        tertiary_phone_number,
        primary_email_id,
        secondary_email_id,
      } = contactInfo;


        setPrimaryContact(primary_phone_number);
        setSecondaryContact(secondary_phone_number);
        setPrimaryEmail(primary_email_id);
        setSecondaryEmail(secondary_email_id);
        setTertiaryPhoneNumber(tertiary_phone_number);

       
    const emails = [primary_email_id];
    const contacts = [primary_phone_number];

    if (secondary_email_id) {
      emails.push(secondary_email_id);
      setShowSecondaryEmail(true);
    }
    if (secondary_phone_number) {
      contacts.push(secondary_phone_number);
      setShowSecondaryContact(true);
    }

    setEmails(emails);
    setContacts(contacts);
  } else {
    console.error("Error fetching basic information:", response?.message);
  }
}




    useEffect(() => {
      if(loginUserId) 
      {
        fetchContactInfo(loginUserId);
      }
    }, [loginUserId]);
  
  return (
    <div className="section">
      <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
        <div className="text-left">Contact Information</div>
        <button onClick={() => toggleSection("contactInfo")}>
          {collapsed ? <FiPlus /> : <FiMinus />}
        </button>
      </div>
      {!collapsed && (
        <div className="section-content px-5 py-12 border-b border-gray-200">
          <div className="flex flex-wrap mt-5 -mx-3">
            {/* Email Update Section */}
            <div className="flex w-full md:w-1/2">
              <div className="flex flex-col w-full">
                {emails.map((email, index) => (
                  <div
                    key={index}
                    className="grid w-full mb-5 grid-cols-[1fr_110px]"
                  >
                    <div className="px-3">
                      <InputComponent
                        label={
                          index === 0
                            ? "Primary Email Address"
                            : "Secondary Email"
                        }
                        id={`email-${index}`}
                        value={index === 0 ? primaryEmail : secondaryEmail}
                        type="text"
                        onChange={(e) =>
                          handleEmailChange(index, e.target.value)
                        }
                        disabled={index === 0 && editButtonsContactInfo !== 1}
                        ref={index === 0 ? emailInputRef : null}
                      />
                    </div>
                    <div className="pr-3 flex gap-1 mt-6">
                      {index === 0 && emails.length < 2 && (
                        <button
                          className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0 min-w-[45px]"
                          onClick={handleAddLogin}
                        >
                          <FiPlus />
                        </button>
                      )}
                      {index > 0 && (
                        <button
                          className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0 min-w-[45px]"
                          onClick={() => handleRemoveLogin(index)}
                        >
                          <FiMinus />
                        </button>
                      )}
                      {index === 0 && (
                        <button
                          className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0 min-w-[45px]"
                          onClick={(e) => setEditButtonsContactInfo(1)}
                        >
                          <FaEdit />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Updated Phone Section */}
            <div className="flex w-full md:w-1/2">
              <div className="flex flex-col w-full">
                {contacts.map((phone, index) => (
                  <div
                    key={index}
                    className="grid w-full mb-5 grid-cols-[1fr_110px]"
                  >
                    <div className="px-3">
                      <InputComponent
                        label={
                          index === 0
                            ? "Primary Contact Number"
                            : "Secondary Contact"
                        }
                        id={`email-${index}`}
                        value={index === 0 ? primaryContact : secondaryContact}
                        type="text"
                        onChange={(e) =>
                          handlePhoneChange(index, e.target.value)
                        }
                        disabled={index === 0 && editButtonsContactInfo !== 2}
                        ref={index === 0 ? phoneInputRef : null} 
                      />
                    </div>
                    <div className="pr-3 flex gap-1  mt-6">
                      {index === 0 && contacts.length < 2 && (
                        <button
                          className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0 min-w-[45px]"
                          onClick={handleAddloginPhone}
                        >
                          <FiPlus />
                        </button>
                      )}
                      {index > 0 && (
                        <button
                          className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0 min-w-[45px]"
                          onClick={() => handleRemoveLoginPhone(index)}
                        >
                          <FiMinus />
                        </button>
                      )}
                      {index === 0 && (
                        <button
                          className="outline-none border-2 border-gray-200 rounded-md focus:ring-blue-600 focus:border-blue-600 w-11 h-11 inline-flex justify-center items-center text-2xl px-0 min-w-[45px]"
                          onClick={(e) => setEditButtonsContactInfo(2)}
                        >
                          <FaEdit />
                        </button>
                      )}
                    </div>
                  </div>
                ))}
                {updatedEmail || updatedPhone ? (
                  <div className="flex gap-2 item-center">
                    <InputComponent
                      label="Verify OTP"
                      id="otp"
                      value={otp}
                      type="text"
                      onChange={(e) => {
                        setOtp(e.target.value);
                      }}
                    />
                    <button
                      className="h-10 w-20 rounded-lg text-sm font-medium text-white bg-[#2E37A4]"
                      onClick={(e) => {
                        if (updatedEmail) {
                          verifyOtpEmailUpdate(e);
                        } else if (updatedPhone) {
                          verifyOtpPhoneUpdate(e);
                        }
                      }}
                    >
                      Verify
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <button
            className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5 bg-[#2E37A4] text-white mt-5"
            onClick={(e) => {
              if (editButtonsContactInfo === 2) {
                updatePhone(e);
              } else if (editButtonsContactInfo === 1) {
                updateEmail(e);
              } else {
                updateContactInfo();
              }
            }}
          >
            Update
          </button>
        </div>
      )}
    </div>
  );
};

export default ContactInfoSection;
